import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import AvatarPage from './pages/AvatarPage';
import ResultadoAvatarPage from './pages/ResultadoAvatarPage';
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import AdminEdicoes from './pages/admin/Edicoes';
import AdminEdicaoDetalhes from './pages/admin/EdicaoDetalhes';
import AdminWhatsappMarketing from './pages/admin/WhatsappMarketing';
import AdminCampanhaDetalhes from './pages/admin/CampanhaDetalhes';
import AdminPlaylist from './pages/admin/Playlist';
import AdminConfiguracoes from './pages/admin/Configuracoes';
import AdminAcessos from './pages/admin/Acessos';
import AdminLayout from './layouts/AdminLayout';
import AuthGuard from './components/admin/AuthGuard';

function App() {
  return (
    <Routes>
      {/* Landing Page */}
      <Route path="/" element={<LandingPage />} />

      {/* Avatar */}
      <Route path="/avatar" element={<AvatarPage />} />
      <Route path="/resultadoavatar" element={<ResultadoAvatarPage />} />
      
      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      
      <Route
        path="/admin"
        element={
          <AuthGuard>
            <AdminLayout />
          </AuthGuard>
        }
      >
        <Route index element={<AdminEdicoes />} />
        <Route path="edicoes" element={<AdminEdicoes />} />
        <Route path="edicoes/:id" element={<AdminEdicaoDetalhes />} />
        <Route path="whatsapp-marketing" element={<AdminWhatsappMarketing />} />
        <Route path="whatsapp-marketing/:id" element={<AdminCampanhaDetalhes />} />
        <Route path="playlist" element={<AdminPlaylist />} />
        <Route path="acessos" element={<AdminAcessos />} />
        <Route path="configuracoes" element={<AdminConfiguracoes />} />
      </Route>
    </Routes>
  );
}

export default App;
